<div class="number-plate-scan">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <sc-flex vertical stretchContent>
        <mat-form-field appearance="outline" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-simulator.number-plate-scanner"></sc-dictionary-label>
          </mat-label>
          <mat-select (valueChange)="onCameraSelection($event)">
            <mat-option *ngFor="let camera of cameras" [value]="camera">
              {{ camera.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <sc-string-field formControlName="numberPlateNumber" labelDictionaryKey="tmc-yard.entity.transport.numberplate">
        </sc-string-field>
      </sc-flex>
    </form>

    <sc-button dictionaryKey="tmc-yard.ui.admin.yard-simulator.send" primary class="config-changed-button" (click)="onButtonTrigger()"
    [disabled]="!numberPlateNumber || !cameraSelected"></sc-button>
  </sc-padding>
</div>
